
import {  ALL_ANSWERS, NEW_ANSWER } from '../actions/constant'

const responses =(responses =[], action) => {
    switch (action.type) {
        case ALL_ANSWERS:
            return action.payload

        case NEW_ANSWER:
            return [...responses, action.payload]
        
        default:
            return responses;
    }
}

export default responses